import { Component } from '@angular/core';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './checkbox-form-field.component.html',
  // Shares select-form-field's styles so both ts-select based fields look the same.
  styleUrls: ['../select-form-field/select-form-field.component.scss', './../form-field.component.scss'],
})
export class CheckboxFormFieldComponent extends FormFieldComponent {
  private _originalValue: any;

  public value: any;
  public options: { id: string; value: string }[] = [
    { id: 'true', value: 'Yes' },
    { id: 'false', value: 'No' },
    { id: 'null', value: 'Not Set' },
  ];

  ngOnInit(): void {
    super.ngOnInit();

    this.initializeInput();
  }

  initializeInput(): void {
    this.value = String(this.model[this.fieldDef.name]);

    if (this.value !== 'null') {
      let booleanValue = new Boolean(this.value);

      if (booleanValue === true || booleanValue === false) {
        this.value = JSON.parse(this.value.toString());
        this._originalValue = this.value;
      }
    }

    this._originalValue = this.value;
  }

  onSelectionChange(value: string): void {
    this.value = value;
    this.onSave();
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: JSON.parse(this.value) });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.initializeInput();
  }
}
